import { useEffect, useRef } from "react";

import { useAppContext } from "../../contexts/AppContext";
import { KeybindManager } from "../../lib/keybinds";

const GRID_SPACING = 8;

export const GridOverlay = () => {
  const { gridOverlay, setGridOverlay, config } = useAppContext<true>();
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    const handleKeybind = () => {
      setGridOverlay((v) => ({ ...v, enabled: !v.enabled }));
    };

    KeybindManager.on("TOGGLE_GRID", handleKeybind);
    return () => {
      KeybindManager.off("TOGGLE_GRID", handleKeybind);
    };
  }, [setGridOverlay]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !gridOverlay.enabled) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = "black"; // full black

    for (let x = 0; x <= canvas.width; x += GRID_SPACING) {
      ctx.fillRect(x, 0, 1, canvas.height); // vertical line as 1px wide column
    }

    for (let y = 0; y <= canvas.height; y += GRID_SPACING) {
      ctx.fillRect(0, y, canvas.width, 1); // horizontal line as 1px tall row
    }
  }, [gridOverlay.enabled]);

  return (
    <canvas
      id="grid-overlay"
      className="no-interact pixelate"
      ref={canvasRef}
      width={config.canvas.size[0] * 8}
      height={config.canvas.size[1] * 8}
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: config.canvas.size[0],
        height: config.canvas.size[1],
        display: gridOverlay.enabled ? "block" : "none",
        opacity: gridOverlay.opacity?.toFixed(1) ?? "1",
        pointerEvents: "none",
      }}
    />
  );
};
